// extracted by mini-css-extract-plugin
module.exports = {"Root":"Alert_Root__3v_Gt","Icon":"Alert_Icon__1L16e","Warning":"Alert_Warning__2Gl0r","Failure":"Alert_Failure__3CobB","Content":"Alert_Content__2CwIQ"};